import { Component } from '@angular/core';

@Component({
  selector: 'app-solution',
  standalone: false,
  templateUrl: './solution.component.html',
  styleUrl: './solution.component.css'
})
export class SolutionComponent {

  constructor() { }

}
